import { render } from "./PageSelectType.vue?vue&type=template&id=25f103ce&ts=true"
import script from "./PageSelectType.vue?vue&type=script&lang=ts"
export * from "./PageSelectType.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__